import React, { Component } from 'react';
import './styles.scss';
import Common from '../../common/services/loadingServices';
import Loading from '../loading';
import Pagination from '../pagination';
import Checkbox from '../../components/checkbox';

const defaultProps = {
    showCheckbox: true,
    showcheckAll: false,
    centerItem: true,
    showAction: false,
    showPagination: true,
    showPaginationTop: false,
    isShowOptionTable: false,
    showScrollX: false,
    onRowClick: () => { },
    onColumnClick: () => { },
    defaultValue: '',
    deliveried: false,
    yearOptions: null,
}

class Table extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageOfItems: [],
            show: false,
            isShowDropdown: false,
            header: null,
            pageSize: null,
            totalPages: null,
            initialPage: null,
            year_id: null
        };
        this.common = Common;
    }

    onChangePage = (page, check) => {
        this.props.onChangePage(page, check)
    }

    UNSAFE_componentWillMount = () => {
        this.setState({ pageOfItems: this.props.itemOfPage, header: this.props.header, meta: this.props.meta });

        if (this.props.yearOptions && this.props.yearOptions.list.length > 0) {
            this.setState({year_id: this.props.yearOptions.list[0].year_id});
        }  

    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        this.setState({ pageOfItems: nextProps.itemOfPage, header: nextProps.header, deliveried: nextProps.deliveried });
        if (nextProps.meta) {
            this.setState({ totalPages: nextProps.meta.last_page, initialPage: nextProps.meta.current_page });
        }
    }


    handleCheckAll(ev) {
        var table = document.getElementById('myTable');
        var checkboxes = table.querySelectorAll('input[type=checkbox]');
        var val = checkboxes[0].checked;
        for (var i = 0; i < checkboxes.length; i++) checkboxes[i].checked = val;
        // this.props.handleCheckAll(ev);
    }

    // handleCheck(ev) {
    //     console.log(ev);
    // }

    handleModal(ev) {
        const modal = document.getElementById('idModal');
        ev === 'open' ? modal.classList.add('show') : modal.classList.remove('show');
    }

    // handleConfirmModal(ev) {
    //     console.log(ev);
    // }

    showLoading = () => {
        this.setState({
            show: true
        })
        this.common.showLoading();
    }

    hide = () => {
        this.common.hideLoading();
    }

    changeShowDropdown = (e) => {
        const selectDropdown = e.target.parentNode.firstChild.nextSibling;
        if (this.state.isShowDropdown) {
            selectDropdown.style.display = 'none';
            this.setState({
                isShowDropdown: false
            })
        } else {
            selectDropdown.style.display = 'block';
            this.setState({
                isShowDropdown: true
            })
        }
    }

    clickOverlay = (e) => {
        const selectDropdown = e.target.parentNode;
        selectDropdown.style.display = 'none';
        this.setState({
            isShowDropdown: false
        })
    }

    offDropdown = (e, key, item) => {
        const selectDropdown = e.target.parentNode;
        selectDropdown.style.display = 'none';
        this.props.actionItemDropdownDot(e, key, item);
    }


    itemInTable = (data) => {
        if (data) {
            return data.item.map((val, i) => {
                if (val.text instanceof Object && val.type !== 'html') {
                    if (val.link) {
                        return <td className="border-0" key={i}>
                            <div onClick={(e) => {
                                if(!this.props.openLink) return;
                                this.props.openLink({
                                    ...val,
                                    finish: true,
                                });
                                e.stopPropagation();
                            }} className="link-double link">
                                <span>{val.text.name}</span>
                                <span>{val.text.action}</span>
                            </div>
                        </td>
                    } else {
                        return <td className="border-0 " key={i}>
                            <div className="link-double" onClick={(e) => {
                                if(!this.props.openLink) return;
                                this.props.openLink({
                                    ...val,
                                    finish: false,
                                });
                                e.stopPropagation();
                            }}>
                                <span>{val.text.name}</span>
                                <span>{val.text.action}</span>
                            </div>
                        </td>
                    }
                } if (val.action) {
                    if (typeof val.action == 'object') {
                        if (this.state.deliveried) {
                            delete val.action['2']
                        }
                        return <td className="border-0 w-4" key={i}>
                            <div className="btn-group dropdown-dot">
                                <img src="/img/ic_dotmore_svg.svg" alt="dot" className=" dropdown-toggle" data-toggle="dropdown"
                                    aria-haspopup="true" aria-expanded="false" onClick={(e) => this.changeShowDropdown(e)} />
                                <div className="dropdown-menu dropdown-menu-right">
                                    <div className="overlay" onClick={(e) => this.clickOverlay(e)} ></div>
                                    {val.action.map((value, key) => {
                                        return <button key={key.toString()}
                                            className="dropdown-item" type="button"
                                            onClick={(e) => this.offDropdown(e, key, data.item, val.id)}>{value}</button>
                                    })}
                                </div>
                            </div>
                        </td>
                    } else {
                        return <td className="border-0 w-4" key={i}>
                            <div className="btn-group dropdown-dot">
                                <img src={val.action} alt="copy" className="" onClick={() => this.actionOther(val)} />
                            </div>
                        </td>
                    }

                } if (val.link) {
                    return (
                        <td className="border-0 isIcon" key={i}>
                            <div className={`flex-table  ${val.img && val.text ? 'justify-left-table' : 'justify-center-table'}`} onClick={(e) => { this.props.openLink(val); e.stopPropagation(); }}>
                                {val.img && val.toggle ?
                                    <span> <img className="icon mr-1 toggle" src={val.src} alt="" onClick={(e) => this.addDataChild(e, data)} /> </span> :
                                    val.img ?
                                        <span> <img className="icon mr-1" alt="team" src={val.img} alt="" /> </span> : ''
                                }
                                <span>{val.text || this.props.defaultValue}</span>
                            </div>
                        </td>
                    )
                } else {

                    return (
                        <td className="border-0 isIcon" key={i} onClick={() => {
                            if(!this.props.onColumnClick) return;
                            this.props.onColumnClick(i, data);
                        }}>
                            <div className={`flex-table  ${val.img && val.text ? 'justify-left-table' : 'justify-center-table'}`}>
                                {val.img && val.toggle ?
                                    <span> <img className="icon mr-1 toggle" src={val.src} alt="" onClick={(e) => this.addDataChild(e, data)} /> </span> :
                                    val.img ?
                                        <span> <img className="icon mr-1" alt="team" src={val.img} alt="" /> </span> : ''
                                }
                                {val.dot ? <span className={`dot dot-${val.dot} mr-1`}></span> : ''}
                                {val.position ? <span className={`position mr-1`}>{val.position}</span> : ''}
                                {/* {val.group ? val.group.map((gr, m) => {
                                    return <p key={m.toString()}>{gr + `${val.group.length > 1 ? '-' : ''}`}</p>
                                }) : ''} */}
                                <span>{(val.text || val.text == 0) ? val.text : this.props.defaultValue}</span>
                            </div>
                        </td>
                    )
                }
            })
        }
    }

    actionOther = (e) => {
        this.props.actionOther(e);
    }

    addDataChild = (e, items) => {
        this.props.resetAddData(items, e);
    }

    render() {

        const { showCheckbox, handleCheckItem, showPaginationTop, showScrollX, showAction, showPagination, showcheckAll, centerItem, getData, isShowOptionTable, titleTable, styleTh, yearOptions } = this.props;
        const header = this.props.header;
        return (
            <div className=" wrap-table"  >
                {
                    titleTable
                        ? <div className={`title-table  align-items-center ` + (titleTable ? titleTable.pl : '')}>
                            {titleTable
                                ? titleTable.dot
                                    ? <div className={"title-circle " + (titleTable.background)}></div>
                                    : false
                                : ''}

                            {titleTable
                                ? <p className="mb-0 title-text">{titleTable.text}</p>
                                : ''}

                            {yearOptions && <div className='title-align-left-box'>
                                <select className="form-control" value={this.state.year_id}
                                    onChange={(e) => {
                                        this.setState({year_id: e.target.value})
                                        yearOptions.getData(yearOptions.player_id, e.target.value);
                                    }}>
                                    {
                                        yearOptions.list.map((val, i) => {
                                            return <option key={i} value={val.year_id}>{val.year}</option>
                                        })
                                    }
                                </select>
                            </div>}

                        </div>
                        : null
                }

                {showPaginationTop ?
                    <Pagination
                        pageSize={this.state.pageSize}
                        showPagination={showPaginationTop}
                        totalPages={this.state.totalPages}
                        initialPage={this.state.initialPage}
                        onChangePage={this.onChangePage}
                    />
                    : ''}

                <div className={showScrollX ? 'overflow-table-large' : 'overflow-table-small'}>
                    <table id="myTable" >
                        <thead>
                            <tr className="header">
                                {showCheckbox && showcheckAll ?
                                    <td className="check">
                                        {/* <div>
                                        <input
                                            type="checkbox"
                                            onClick={() => this.handleCheckAll(this.state.pageOfItems)} />
                                    </div> */}
                                        <div className="md-checkbox-custom">
                                            <input type="checkbox" value="check" />
                                            <label></label>
                                        </div>
                                    </td> : null}

                                {header && header.map((items, index) => (
                                    styleTh
                                        ? <th key={index.toString()} >{items}</th>
                                        : <th key={index.toString()} className={!styleTh ? 'border-0 text-center' : ''} >
                                            <span className={!styleTh ? 'span-th' : ''}>{items}</span>
                                        </th>
                                ))}
                                {showAction ?
                                    <td> </td> : null}
                            </tr>

                        </thead>
                        <tbody>
                            {
                                this.state.pageOfItems && this.state.pageOfItems.map((items, index) => (
                                    <tr className={centerItem ? 'item-center' : 'item-left'} key={index.toString()} onClick={() => this.props.onRowClick(items, index)}>
                                        {showCheckbox &&
                                            <td className="check border-0">
                                                <Checkbox checked={!!items.deliveried_at} onChange={(ev) => handleCheckItem(items, ev)}/>
                                            </td>
                                        }
                                        {this.itemInTable(items)}
                                    </tr>

                                ))}
                        </tbody>
                    </table>
                </div>
                {showPagination ?
                    <Pagination
                        pageSize={this.state.pageSize}
                        showPagination={showPagination}
                        totalPages={this.state.totalPages}
                        initialPage={this.state.initialPage}
                        onChangePage={this.onChangePage}
                    /> : ''}

                {isShowOptionTable ?
                    <div className="p-1">
                        <button onClick={() => this.handleModal('open')} className="btn btn-primary">alert</button>
                        <button onClick={this.showLoading} className="btn btn-primary">show-loading</button>
                        <button onClick={this.hide} className="btn btn-primary">hide-loading</button>
                        <button onClick={getData} className="btn btn-primary">Get data</button>
                    </div> : ''}

                <Loading show={this.state.show} />
            </div>
        )
    }
}

Table.defaultProps = defaultProps;
export default Table
